import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from 'vue-auto-routing';
import { createRouterLayout } from 'vue-router-layout';
// import Amplify from 'aws-amplify';
import utils from '@/services/utils';
import store from '@/store';

Vue.use(VueRouter);

// eslint-disable-next-line arrow-body-style
const RouterLayout = createRouterLayout((layout) => {
  // eslint-disable-next-line prefer-template
  return import('@/layouts/' + layout + '.vue');
});

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: RouterLayout,
      children: routes,
    },
  ],
});

router.beforeResolve(async (to, from, next) => {
  // console.log(`router.beforeResolve - start: ${from.path} --> ${to.path}`);
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    const { user } = store.state;
    if (user) {
      next();
    } else {
      if (to.name === 'm-member') {
        localStorage.setItem('redirectPath', to.fullPath);
      }
      utils.setStatusMsg(router.app, 'Please sign in and try again.');
      next({
        path: '/m/login',
      });
    }
  } else {
    next();
  }

  if (to.matched.some((record) => record.meta.requireAdmin)) {
    const { user } = store.state;
    if (user) {
      next();
    } else {
      utils.setStatusMsg(
        router.app,
        'Please sign in with admin and try again.',
      );
      next({
        path: '/m/login',
      });
    }
  } else {
    next();
  }
});

export default router;
